import { loadStripe } from "@stripe/stripe-js/pure";

// VIVA-1214 — instancia de Stripe.js compartida.
//
// Mismo criterio que `purchaseHistory/utils/Stripe/PaymentModal.jsx`: se carga
// una sola vez por llave publicable, y se usa la cuenta de la PLATAFORMA (sin
// `stripeAccount`), porque el PaymentIntent de guías lo crea API.Stripe en la
// cuenta de la plataforma. PaymentModal conserva su propia copia; no se migró
// aquí para no tocar el cobro de reservas dentro de este ticket.

let cachedKey = null;
let cachedPromise = null;

export const getStripePublishableKey = () => {
  const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  return typeof key === "string" && key.startsWith("pk_") ? key : "";
};

export const getStripePromise = () => {
  const key = getStripePublishableKey();
  if (!key) return null;

  if (!cachedPromise || cachedKey !== key) {
    cachedKey = key;
    cachedPromise = loadStripe(key);
  }

  return cachedPromise;
};

// Un clientSecret de PaymentIntent tiene la forma pi_xxx_secret_yyy. Si no la
// tiene, montar Elements solo produce un formulario roto.
export const isPaymentIntentClientSecret = (secret) =>
  /^pi_[^_]+_secret_.+/.test(String(secret || ""));
